// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import SuiVue from 'semantic-ui-vue'
import 'semantic-ui-css/semantic.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueSweetalert2 from 'vue-sweetalert2'
import VueGoodTablePlugin from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'
//import VueCharts from 'vue-charts'
import Trend from 'vuetrend'
import 'chart.js'
import 'hchs-vue-charts'
import VueHtml2Canvas from 'vue-html2canvas'
// import babelPolyfill from 'babel-polyfill'

Vue.use(VueHtml2Canvas);
Vue.use(window.VueCharts);
Vue.use(Trend);
Vue.use(VueGoodTablePlugin)
Vue.use(VueSweetalert2)
Vue.use(VueAxios, axios)
Vue.config.productionTip = false
Vue.use(SuiVue)
Vue.use(store)

Vue.prototype.$months = new Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');
Vue.prototype.$primary_color_default = '#00f9a9'
Vue.prototype.$sh_status = {
  'new': 'new',
  'in-apt': 'en armario',
  'delivered': 'entregado',
  'to-term': 'retirado por comercio'
}
axios.get("static/config.json").then(response => {
  Vue.prototype.$url_hapiick = response.data.URL;
  // console.log('Entorno ' + Vue.prototype.$url_hapiick)

/*   if (Vue.prototype.$url_hapiick === 'https://api.hapiick.com') { //API MANAGEMENT PROD
    Vue.prototype.$apim_url = 'https://hapiickapi.azure-api.net/admin'
    Vue.prototype.$apim_subscription_key = '073dff8d9a3d447cba701533fbccd5af'
  } else if (Vue.prototype.$url_hapiick === 'https://test.hapiick.com') { //API MANAGEMENT TEST
    Vue.prototype.$apim_url = 'https://apihapiickser.azure-api.net/admin'
    Vue.prototype.$apim_subscription_key = 'f10b200964f24d1689b0a9aa6f6a26d4'
  } else {
    Vue.prototype.$apim_url = '';
    Vue.prototype.$apim_subscription_key = '';
  } */

  new Vue({
    el: '#app',
    router,
    store,
    components: { App},
    template: '<App/>'
  })

});









// WEBPACK FOOTER //
// ./src/main.js